import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que asegura que la vista vuelva al inicio (top 0)
 * cada vez que cambia la ruta, deshabilitando la restauración automática
 * del scroll del navegador para cumplir con el requerimiento de
 * "volver al inicio de la página y no a la posición del scroll".
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Forzar el scroll al inicio en cada cambio de ruta
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        // Deshabilitar la restauración automática del scroll del navegador
        // Esto evita que al dar "Atrás", el navegador intente volver a la posición anterior.
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Opcional: Restaurar a 'auto' si el componente se desmonta (aunque en App.jsx vivirá siempre)
        return () => {
            if ('scrollRestoration' in window.history) {
                window.history.scrollRestoration = 'auto';
            }
        };
    }, []);

    return null;
}
